import {
  Box,
  Step,
  StepDescription,
  StepIcon,
  StepIndicator,
  StepNumber,
  Stepper,
  StepSeparator,
  StepStatus,
  StepTitle,
  Text,
  useSteps
} from "@chakra-ui/react";
import { ContatoType } from "models/contato_type";
import { PessoaType } from "models/person_type";
import { Project } from "models/project_type";
import { UsuarioModel } from "models/user_model";
import EntregasComponent from "./EntregasComponent";
import ExecutivaComponent from "./ExecutivaComponent";
import FechamentoComponent from "./FechamentoComponent";
import FinanceiroComponent from "./FinanceiroComponent";
import HomeComponent from "./HomeComponent";
import JuridicoComponent from "./JuridicoComponent";

interface ITimeLineProject {
    accountSelected : Project
    users: UsuarioModel[];
    contatoAgencia: ContatoType;
    contatoCliente: ContatoType;
    clients : PessoaType[];
}

const TimeLineProject = ({accountSelected, users, contatoAgencia, contatoCliente, clients} : ITimeLineProject) => {
  const steps = [
    { title: "Home", description: "Confêrencia de Orçamento" },
    { title: "Executiva", description: "Lançamento do Projeto" },
    { title: "Júridico", description: "Contrato e itens legais" },
    { title: "Financeiro", description: "Pagamentos e OS." },
    { title: "Entregas", description: "Entregáveis e Prévias" },
    { title: "Fechamento", description: "Finalização do Projeto" },
  ];
  const { activeStep, setActiveStep } = useSteps({
    index: 0,
    count: steps.length,
  });

  const renderItens = () => {
    let component;

    switch (activeStep) {
      case 0:
        component = <HomeComponent accountSelected={accountSelected} users={users} contatoAgencia={contatoAgencia} contatoCliente={contatoCliente}/>;
        break;
      case 1:
        component = <ExecutivaComponent accountSelected={accountSelected} />;
        break;

      case 2:
        component = <JuridicoComponent  accountSelected={accountSelected}  clients={clients}/>;
        break;
      case 3:
        component = <FinanceiroComponent />;
        break;
      case 4:
        component = <EntregasComponent />;
        break;
      case 5:
        component = <FechamentoComponent />;
        break;
    }
    return component;
  };
  return (
    <>
      <Text mt={8} fontSize={18} color={"#422AFB"} fontWeight={"bold"} mb={4}>
        Timeline do Projeto
      </Text>

      <Stepper size="lg" index={activeStep}>
        {steps.map((step, index) => (
          <Step key={index} onClick={() => setActiveStep(index)}>
            <StepIndicator>
              <StepStatus
                complete={<StepIcon />}
                incomplete={<StepNumber />}
                active={<StepNumber />}
              />
            </StepIndicator>

            <Box flexShrink="0">
              <StepTitle>{step.title}</StepTitle>
              <StepDescription>{step.description}</StepDescription>
            </Box>
            <StepSeparator />
          </Step>
        ))}
      </Stepper>
      {renderItens()}
    </>
  );
};
export default TimeLineProject;
